module.exports = __webpack_public_path__ + "static/img/tianboss.e5a2f21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/geren/photos/tianboss.jpg
// module id = K7LD
// module chunks = 36